import { Action } from 'redux';

import {
  FetchScalesParams,
  ScaleIncludeParam,
  ScaleType,
  ScaleVisualization,
  ScalesRespI, Scale,
} from '~src/interfaces/scale.interface';
import { ContentLocalesI } from '~src/interfaces/session.types';
import {
  ADD_SCALE_FAILED,
  ADD_SCALE_REQUEST,
  ADD_SCALE_SUCCESS,
  DELETE_SCALE_FAILED,
  DELETE_SCALE_REQUEST,
  DELETE_SCALE_SUCCESS,
  EDIT_SCALE_FAILED,
  EDIT_SCALE_REQUEST,
  EDIT_SCALE_SUCCESS,
  GET_SCALES_FAILED,
  GET_SCALES_REQUEST,
  GET_SCALES_SUCCESS,
  GET_SCALE_FAILED,
  GET_SCALE_REQUEST,
  GET_SCALE_SUCCESS,
  RESET_SCALES,
} from '~src/modules/scales/constants/actionTypes';
import { defaultPulseCheckApi, pulseCheck } from '~src/services/ApiController';
import { AsyncAction } from '~src/services/apiMiddleware';

export interface NewScaleSubmitData {
  name: ContentLocalesI;
  type: ScaleType;
  visualization: ScaleVisualization;
}

export interface EditScaleFormData {
  name: ContentLocalesI;
  description: ContentLocalesI;
}

export interface EditLabelsFormData {
  labels: Array<ContentLocalesI>;
}

/*
type UpdateScale struct {
	ID                      id.ID        `db:"id" json:"-"`
	Name                    i18n.String  `db:"name" json:"name"`
	Description             i18n.String  `db:"description" json:"description"`
	Labels                  i18n.Strings `db:"labels" json:"labels"`
	MultiplechoiceOptions   i18n.Strings `db:"multiple_choice_options" json:"multipleChoiceOptions"`
	IsMultipleChoiceEnabled *bool        `db:"is_multiple_choice_enabled" json:"isMultipleChoiceEnabled"`
}
 */
export interface UpdateScaleSubmitData {
  name: ContentLocalesI;
  description: ContentLocalesI;
  labels: ContentLocalesI[];
  multipleChoiceOptions: ContentLocalesI[];
  isMultipleChoiceEnable: boolean;
}

export interface EditMcqOptionsFormData {
  multipleChoiceOptions: ContentLocalesI[];
  isMultipleChoiceEnabled: boolean;
}

export const fetchScales = (
  params?: FetchScalesParams,
): AsyncAction<ScalesRespI, undefined | { withVersions: boolean; includeDeleted: boolean }> => {
  let payload;
  if (params && params.include) {
    payload = {
      withVersions: params.include.indexOf(ScaleIncludeParam.ScaleVersion) !== -1,
      includeDeleted: params.include.indexOf(ScaleIncludeParam.ScaleDeleted) !== -1,
    };
  }
  return {
    types: [GET_SCALES_REQUEST, GET_SCALES_SUCCESS, GET_SCALES_FAILED],
    callAPI: () => defaultPulseCheckApi.getScales(params),
    payload,
  };
};

export function getScale(id: string): AsyncAction<Scale, {id: string}> {
  return {
    types: [GET_SCALE_REQUEST, GET_SCALE_SUCCESS, GET_SCALE_FAILED],
    callAPI: () => pulseCheck.get(`/scales/${id}`),
    payload: { id },
  };
}

export function resetScales(): Action {
  return { type: RESET_SCALES };
}

export function addScale(scale: NewScaleSubmitData): AsyncAction<ScalesRespI, NewScaleSubmitData> {
  return {
    types: [ADD_SCALE_REQUEST, ADD_SCALE_SUCCESS, ADD_SCALE_FAILED],
    callAPI: () => pulseCheck.post('/scales', scale),
    payload: scale,
  };
}

export function editScale(
  id: string,
  payload: Partial<UpdateScaleSubmitData>,
): AsyncAction<Scale, {id: string, payload: Record<string, unknown> | EditLabelsFormData | EditMcqOptionsFormData}> {
  return {
    types: [EDIT_SCALE_REQUEST, EDIT_SCALE_SUCCESS, EDIT_SCALE_FAILED],
    callAPI: () => pulseCheck.patch(`/scales/${id}`, payload),
    payload: { id, payload },
  };
}

export function deleteScale(id: string, name: ContentLocalesI): AsyncAction<undefined, {id: string, name: ContentLocalesI}> {
  return {
    types: [DELETE_SCALE_REQUEST, DELETE_SCALE_SUCCESS, DELETE_SCALE_FAILED],
    callAPI: () => pulseCheck.delete(`/scales/${id}`),
    payload: { id, name },
  };
}
